const ShopCardProductMv = 'b_sailor_c_n7vcwalw_mv';
const ShopCardProductMc = 'b_sailor_c_n7vcwalw_mc';

const Statistics = Mach.requireModule('Statistics');

export const reportProductMv = (params: {cid: string; logData: any; }) => {
  const cid = params?.cid;
  const logData = params?.logData;
  Statistics.view(cid, ShopCardProductMv, logData);
};

export const reportProductMc = (params: {cid: string; logData: any; }) => {
  const cid = params?.cid;
  const logData = params?.logData;
  Statistics.setTag && Statistics.setTag('sailor_c', {
    [cid]: {
      ...params,
      bid: ShopCardProductMc,
    },
  });
  Statistics.click(cid, ShopCardProductMc, logData);
};

globalThis.reportSet = new Set();
